import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CRMActions = require("lib/actions/CRMActions");
var CRMSelectors = require("lib/selectors/CRMSelectors");

var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");

@connect(
	(state, props) => {
		var dealID = $wr.getURLParameterByName("deal_id");

		if (dealID) {
			var deal = CRMSelectors.deal({ state, id: $wr.getURLParameterByName("deal_id") });
		}

		var loading = !!(
			CRMSelectors.isLoadingDeals({ state, key: dealID }) ||
			CRMSelectors.isLoadingDeals({ state, key: "create" })
		)

		return {
			deal, loading
		}

	},
	(dispatch, props) => ({
		populateData: () => {
			var dealID = $wr.getURLParameterByName("deal_id");
			if (dealID) {
				return dispatch(CRMActions.fetchDeal({
					id: dealID, embeds: ["deal.org", "deal.contact"]
				}))
			}
		},


		cloneDeal: (type) => {
			var dealID = $wr.getURLParameterByName("deal_id");

			return dispatch(CRMActions.createDeal({
				query: { clone_deal_id: dealID, type }
			})).then((result) => {
				return result.deals[0];
			})
		},
	})
)
@providePopulateData()
class DealTransformsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			blankDealID: undefined,
			sideDealID: undefined,
			renewalDealID: undefined,
		};
	}

	renderNewBlankDeal() {
		if (this.state.blankDealID) {
			var cloneURL = DEAL_LINK_BASE + this.state.blankDealID;

			var content = (
				<div>
					New Deal: <a href={ cloneURL } target="_blank">
						<Glyphicon icon="link" /> { cloneURL }
					</a>
				</div>
			);

		} else {
			var handler = () => {
				this.props.cloneDeal("blank").then((newDealData) => {
					this.setState({ blankDealID: newDealData.id });
				})
			}

			var content = (
				<div>
					<p>
						For bringing back lost deals
					</p>
					<p class="smallText">
						Adds a deal with same org/contact, not linked
						in any way to this deal. Completely blank.
					</p>
					<LoadingButton loading={ this.props.loading } text="Go!"
						className="btn buttonPrimary"
						onClick={ handler } />
				</div>
			);
		}

		return (
			<div>
				<h3>New Blank Deal</h3>
				{ content }
			</div>
		)
	}

	renderNewSideDeal() {
		if (this.state.sideDealID) {
			var cloneURL = DEAL_LINK_BASE + this.state.sideDealID;

			var content = (
				<div>
					New Deal: <a href={ cloneURL } target="_blank">
						<Glyphicon icon="link" /> { cloneURL }
					</a>
				</div>
			);

		} else {
			var handler = () => {
				this.props.cloneDeal("side").then((newDealData) => {
					this.setState({ sideDealID: newDealData.id });
				})
			}

			var content = (
				<div>
					<p>
						For expansions, late RLD additions, etc.
					</p>
					<p class="smallText">
						Adds a deal with same org/contact, linked to this
						deal via Main/Side Deal ID. Otherwise blank.
					</p>
					<LoadingButton loading={ this.props.loading } text="Go!"
						className="btn buttonPrimary"
						onClick={ handler } />
				</div>
			);
		}

		return (
			<div>
				<h3>New Side Deal</h3>
				{ content }
			</div>
		)
	}

	renderNewRenewalDeal() {

		if (this.state.renewalDealID) {
			var cloneURL = DEAL_LINK_BASE + this.state.renewalDealID;

			var content = (
				<div>
					New Deal: <a href={ cloneURL } target="_blank">
						<Glyphicon icon="link" /> { cloneURL }
					</a>
				</div>
			);

		} else {
			var handler = () => {
				this.props.cloneDeal("renewal").then((newDealData) => {
					this.setState({ renewalDealID: newDealData.id });
				})
			}

			var content = (
				<div>
					<p>
						For renewals (pending, won, or lost).
					</p>
					<p class="smallText">
						Adds a deal with same org/contact, linked to this
						deal via Forward/Backward Deal ID. Same plan type,
						class count, etc.
					</p>
					<LoadingButton loading={ this.props.loading } text="Go!"
						className="btn buttonPrimary"
						onClick={ handler } />
				</div>
			);
		}

		return (
			<div>
				<h3>New Renewal Deal</h3>
				{ content }
			</div>
		)
	}

	render() {
		if (this.props.deal) {
			var dealName = this.props.deal.name;
			var dealLink = (
				<a href={ DEAL_LINK_BASE + this.props.deal.id } target="_blank">
					<Glyphicon icon="link" />
				</a>
			)
		}
		return (
			<div className="dealTransformsPage container">
				<div className="headerSection">
					<header className="pageHeader">
						<h1>Deal Transforms</h1>
					</header>
				</div>

				<p>
					<strong>Deal</strong>: { dealName } { dealLink }
				</p>

				<div class="row">
					<div class="col-sm-6">
						{ this.renderNewRenewalDeal() }
					</div>
					<div class="col-sm-6">
						{ this.renderNewSideDeal() }
					</div>
				</div>


				<hr />

				<div class="row">
					<div class="col-sm-6">
						{ this.renderNewBlankDeal() }
					</div>
					<div class="col-sm-6">
					</div>
				</div>


			</div>
		);
	}

};

var DEAL_LINK_BASE = "https://app.futuresimple.com/sales/deals/";

DealTransformsPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	deal: PropTypes.object,
	loading: PropTypes.bool,

	// Handlers from @connect
	populateData: PropTypes.func.isRequired,
	cloneDeal: PropTypes.func.isRequired,
});

module.exports = DealTransformsPage;



// WEBPACK FOOTER //
// ./modules/components/appdev/crm/DealTransformsPage.js